module.exports = __webpack_public_path__ + "static/media/HCMM255.34dcfb0a.jpg";